import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, mergeProps as _mergeProps, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { Message } from "primevue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'UText',
    props: {
        severity: { default: "info" },
        variant: { default: "simple" },
        size: { default: "small" },
        closable: { type: Boolean, default: false },
        sticky: { type: Boolean, default: true },
        life: { default: undefined },
        content: { default: "" }
    },
    emits: ["close"],
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(Message), _mergeProps({
                severity: __props.severity,
                variant: __props.variant,
                size: __props.size,
                closable: __props.closable,
                sticky: __props.sticky,
                life: __props.life
            }, _ctx.$attrs, {
                onClose: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('close')))
            }), _createSlots({
                default: _withCtx(() => [
                    _renderSlot(_ctx.$slots, "default", {}, () => [
                        _createTextVNode(_toDisplayString(__props.content), 1)
                    ])
                ]),
                _: 2
            }, [
                (_ctx.$slots.icon)
                    ? {
                        name: "icon",
                        fn: _withCtx(() => [
                            _renderSlot(_ctx.$slots, "icon")
                        ]),
                        key: "0"
                    }
                    : undefined
            ]), 1040, ["severity", "variant", "size", "closable", "sticky", "life"]));
        };
    }
});
